import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { BrandMark } from "../BrandMark.js";
export function AgentAvatar({ logoUrl, brand, className, monogram, }) {
    // A logo whose storage object went missing must degrade to the mark rather
    // than render a broken image on a prospect's screen.
    const [failed, setFailed] = useState(false);
    if ((!logoUrl || failed) && monogram) {
        return (_jsx("span", { "aria-hidden": "true", className: `shrink-0 rounded-[8px] bg-brand-primary text-brand-primary-fg flex items-center justify-center text-[13px] font-semibold leading-none ${className ?? ""}`, children: monogram }));
    }
    if (!logoUrl || failed) {
        return (
        // No `label`: beside a message bubble that already identifies the sender,
        // the mark is decoration, and naming it on every single message is noise in
        // a screen reader. `label` exists for surfaces where the mark stands alone.
        _jsx(BrandMark, { className: `shrink-0 rounded-[8px] ${className ?? ""}`, shape: brand?.mark.shape, colors: brand?.colors }));
    }
    return (_jsx("img", { src: logoUrl, alt: "", onError: () => setFailed(true), 
        // `object-contain` on white: school logos are rarely square, and cropping
        // a wordmark to fill the box is worse than letterboxing it.
        className: `shrink-0 rounded-[8px] bg-white object-contain ${className ?? ""}` }));
}
//# sourceMappingURL=AgentAvatar.js.map